import { type GroupBase } from 'react-select';
import ReactAsyncCreatableSelect from 'react-select/async-creatable';

import { SelectLoadError } from './SelectLoadError';
import { type AsyncCreatableSelectProps, type AsyncOption } from './types';
import { useAsyncSelectProps } from './useAsyncSelectProps';

export function AsyncCreatableSelect<
  TItem,
  TPageParam = number,
  TFilters = undefined,
>(props: AsyncCreatableSelectProps<TItem, TPageParam, TFilters>) {
  const { commonProps, control, filtersKey, loadError, testId } =
    useAsyncSelectProps(props, { isCreatable: true });

  return (
    <div data-testid={testId}>
      <ReactAsyncCreatableSelect<
        AsyncOption<TItem>,
        boolean,
        GroupBase<AsyncOption<TItem>>
      >
        key={filtersKey}
        {...commonProps}
        loadOptions={control.loadOptions}
      />
      <SelectLoadError error={loadError} />
    </div>
  );
}
